export function isInvestmentsRoute(routeName) {
  return routeName && (routeName.startsWith('banking-engine.investments') || routeName.startsWith('banking.investments'));
}